import { Chat } from '../components/chat/Chat';

// Chat tracking setup doesn't need to block the critical path. Defer until the
// browser is idle so it runs after first paint and chunk parsing. Fall back to
// setTimeout for browsers that don't support requestIdleCallback (e.g. Safari).
export function setupChatTracking() {
  const idleCallback = window.requestIdleCallback;
  if (typeof idleCallback === 'function') {
    idleCallback(() => {
      Chat.setupTracking();
    });
  } else {
    setTimeout(() => {
      Chat.setupTracking();
    }, 0);
  }
}